import type { GrantedUsersFetchedPayload } from '@Application/SubjectTypeDefinitions/Actions/grantedUsersFetched';
import GrantableUserView from '@UI/Store/SubjectTypeDefinitions/Views/GrantableUserView';

/** The users already granted, resolved for one account and one set of requested ids. */
class GrantedUsersListView {
	readonly list: readonly GrantableUserView[];
	readonly accountId: number;
	// Requested ids, sorted: a deleted user never makes the read look unresolved.
	readonly ids: readonly number[];

	constructor(payload: GrantedUsersFetchedPayload, accountId: number, ids: readonly number[]) {
		this.list = payload.map((user) => new GrantableUserView(user));
		this.accountId = accountId;
		this.ids = [...ids].sort((first, second) => first - second);

		Object.freeze(this);
	}

	isFor(accountId: number, ids: readonly number[]): boolean {
		if (this.accountId !== accountId || this.ids.length !== ids.length) {
			return false;
		}

		const sortedIds = [...ids].sort((first, second) => first - second);

		return this.ids.every((id, index) => id === sortedIds[index]);
	}
}

export default GrantedUsersListView;
